import React, { useState, useEffect } from 'react';
import FarmDetails from './components/FarmDetails';
import Header from './components/Header';
import LoadingSpinner from './components/LoadingSpinner';
import './App.css';

function App() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [farmId, setFarmId] = useState(null);
  const [user, setUser] = useState('Unknown');

  useEffect(() => {
    // Parse URL query parameters
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get('id');
    const username = queryParams.get('user');

    if (!id) {
      setError('Missing farm ID in URL. Please include ?id=FARM_ID in the URL.');
      setLoading(false);
      return;
    }

    setFarmId(id);
    if (username) setUser(username);
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="App">
        <Header />
        <div className="flex justify-center items-center h-64">
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="App">
        <Header />
        <div className="text-center p-8">
          <h1 className="text-xl text-center p-2 font-bold text-gray-900">Error!</h1>
          <h2 className="text-center text-gray-700 p-1">{error}</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <FarmDetails farmId={farmId} user={user} />
    </div>
  );
}

export default App;